import { render, staticRenderFns } from "./CoBookingDetailView.vue?vue&type=template&id=38574b6e&"
import script from "./CoBookingDetailView.vue?vue&type=script&lang=ts&"
export * from "./CoBookingDetailView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports